import React from 'react'
import styled from 'styled-components'
import { Modal, Progress, Space, Spin } from 'antd'
import {
  CheckCircleFilled,
  CiCircleFilled,
  ClockCircleFilled,
  CloseCircleFilled,
  LoadingOutlined,
  WarningFilled,
} from '@ant-design/icons'
import Theme, { MyTheme } from 'Components/common/Theme'
import { numberWithComma } from 'helpers/format'
import { ceil } from 'lodash'
import { Event } from 'Store/common/common.types'
import { PrimaryButton } from 'Components/button'

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />

interface Props {
  isShow: boolean
  time?: number
  text?: string
  callback?: () => void
  percent?: number
  total: number
  success: number
  chunkSize: number
  event: Event[]
  err?: Event[]
  enable?: boolean
  successCalback?: () => void
  errorCalback?: () => void
  evt?: any
  chunkData?: { start: number; end: number }[]
}

const css: any = {
  page: {
    textAlign: 'center',
    fontSize: '20px',
    color: 'white',
  },
  spin: {
    color: 'white',
    fontSize: '70px',
  },
}

const ProgressLoadingView = (props: Props) => {
  const {
    isShow = false,
    percent = 100,
    total,
    success,
    chunkSize,
    event,
    err,
    enable,
    successCalback,
    errorCalback,
    evt,
    chunkData = [],
  } = props

  // const renderDescription = () => {
  //   const element = [] as any[]
  //   const round = ceil(total / chunkSize)
  //   let lastRecord = 0
  //   console.log('round', round)
  //   console.log('success', success)
  //   for (let index = 1; index <= round; index++) {
  //     const isInprogress = success === index * chunkSize
  //     const isSuccess = index * chunkSize < success
  //     let icon = <CheckCircleFilled style={{ color: '#999999' }} />
  //     if (isInprogress) {
  //       icon = <LoadingOutlined color="#52c41a" />
  //       if (!!evt.SubmitError && enable) {
  //         icon = <CloseCircleFilled style={{ color: 'red' }} />
  //       }
  //     }
  //     if (isSuccess) {
  //       icon = <CheckCircleFilled style={{ color: '#52c41a' }} />
  //     }
  //     const lastRow = lastRecord + chunkSize > total ? total : lastRecord + chunkSize

  //     element.push(
  //       <div>
  //         {icon} &nbsp; รายการสินค้าลำดับที่ {lastRecord + 1} - {lastRow}
  //         {isInprogress && !!evt.SubmitError && enable && <ErrorMessage>{evt.SubmitError}</ErrorMessage>}
  //       </div>,
  //     )
  //     lastRecord = index * chunkSize
  //   }
  //   return element
  // }

  const renderDescription = () => {
    return (
      chunkData &&
      chunkData.map((item, index: number) => {
        const isInprogress = success === item.end
        const isSuccess = item.end < success
        let icon = <CheckCircleFilled style={{ color: '#999999' }} />
        if (isInprogress) {
          icon = <LoadingOutlined color="#52c41a" />
          if (!!evt.SubmitError && enable) {
            icon = <CloseCircleFilled style={{ color: 'red' }} />
          }
        }
        if (isSuccess) {
          icon = <CheckCircleFilled style={{ color: '#52c41a' }} />
        }
        return (
          <div key={index}>
            {icon} &nbsp; รายการสินค้าแถวที่ {item.start} - {item.end}
            {isInprogress && !!evt.SubmitError && enable && <ErrorMessage>{evt.SubmitError}</ErrorMessage>}
          </div>
        )
      })
    )
  }

  return (
    <Modal
      wrapClassName="progress-box"
      style={css.page}
      visible={isShow}
      closable={false}
      mask={false}
      footer={null}
      centered
    >
      <Body>
        <Space direction="vertical">
          {/* <LoadingSpin size="large" indicator={antIcon} style={css.spin} /> */}
          <LoadingSpin
            type="circle"
            percent={percent}
            width={80}
            format={percent => `${numberWithComma(percent || 0, true, 0)}%`}
            trailColor={Theme.colors.white}
            strokeColor={Theme.colors.success}
          />
          <p>กำลังนำสินค้าเข้าระบบ กรุณารอซักครู่...</p>
          <Description>{renderDescription()}</Description>
          {!!evt.SubmitError && enable && (
            <ButtonAction>
              <PrimaryButton text={'จบการทำงาน'} btnType={'Reject'} size="middle" onClick={errorCalback} />
            </ButtonAction>
          )}
        </Space>
      </Body>
    </Modal>
  )
}

const Body = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  height: auto;
  // height: 125px;
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.regular};
`

const Description = styled.div`
  padding: 0px 0;
  width: 100%;
  text-align: left;
`
const ErrorMessage = styled.div`
  padding-left: 30px;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error} !important;
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4} !important;
`

const ButtonAction = styled.div`
  padding: 10px 0;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
`

const LoadingSpin = styled(Progress)`
  span {
    color: ${(props: { theme: MyTheme }): string => props.theme.colors.white} !important;
  }
`

export default ProgressLoadingView
